import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import config from "../../Config";

export function getSupportAttachmentFileName(source) {
    if (!source) {
        return "";
    }
    if (typeof source === "string") {
        return source.trim();
    }
    const name = source.FileAttached ?? source.fileAttached ?? "";
    return typeof name === "string" ? name.trim() : "";
}

export function hasSupportAttachment(source) {
    return getSupportAttachmentFileName(source).length > 0;
}

export function supportAttachmentUrl(source) {
    const fileName = getSupportAttachmentFileName(source);
    if (!fileName) {
        return "";
    }

    let root = config.root;
    if (!root && config.base_url) {
        root = config.base_url.replace(/\/api\/?$/i, "/");
    }
    root = (root || "/").replace(/\/?$/, "/");

    return `${root}SupportTicket/SupportFiles/${encodeURIComponent(fileName)}`;
}

export function SupportAttachmentActions({ source, onView, label = "View attachment" }) {
    const fileName = getSupportAttachmentFileName(source);
    if (!fileName) {
        return null;
    }

    const url = supportAttachmentUrl(fileName);

    return (
        <div className="attachment-wrap">
            <button
                type="button"
                className="button-view-attachment"
                onClick={() => onView(fileName)}
            >
                <i className="ri-attachment-line" />
                {label}
            </button>
            <button
                type="button"
                className="support-attachment-thumb"
                onClick={() => onView(fileName)}
                title="View attachment"
            >
                <img src={url} alt="" />
            </button>
        </div>
    );
}

function SupportAttachmentViewer({ show, fileName, onHide }) {
    const [loadError, setLoadError] = useState(false);
    const resolvedName = getSupportAttachmentFileName(fileName);
    const url = supportAttachmentUrl(resolvedName);

    const handleHide = () => {
        setLoadError(false);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleHide}
            centered
            size="lg"
            className="support-attachment-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>View attachment</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                {resolvedName && url ? (
                    <>
                        {!loadError ? (
                            <img
                                src={url}
                                className="img-fluid support-attachment-preview"
                                alt="Attachment"
                                onError={() => setLoadError(true)}
                            />
                        ) : (
                            <p className="text-muted mb-3">
                                Could not load the image preview.
                            </p>
                        )}
                        <a
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="button button-outline-primary mt-2"
                        >
                            Open in new tab
                        </a>
                    </>
                ) : null}
            </Modal.Body>
        </Modal>
    );
}

export default SupportAttachmentViewer;
